/* eslint-disable @typescript-eslint/no-require-imports */
/**
 * Application Configuration Barrel File
 *
 * Uses require() inside if/else so webpack can eliminate the dead branch
 * (and its require() call) entirely via dead code elimination.
 * Static imports can't be tree-shaken this way because they're hoisted.
 * This file is required to disable the no-require-imports rule.
 * In order to enable the threeshaking feature that removes unrelated envs specific code from the builds output.
 */

import type { AppConfig } from './types';

export const PRODUCTION = process.env.TARGET_FIREBASE === 'production';

let config: AppConfig;

if (process.env.TARGET_FIREBASE === 'production') {
	config = require('./config.production').default;
}
else {
	config = require('./config.staging').default;
}

export default config;
